import React from 'react';
import { eventOptions, eventRecommendation, eventTruths } from '../../data/architecture';
const verdictStyles: Record<string, string> = {
  Recommended: 'bg-olive text-white',
  'Budget option': 'bg-opal text-ink',
  'Limited use': 'bg-creme text-ink',
  'Only if you love spreadsheets': 'bg-peach text-ink'
};
export function EventsPlan() {
  return <section aria-labelledby="events-h" className="border-t border-line bg-white" data-id="element-206" data-mp="2ky1lya4j2ikc">
      <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-207" data-mp="3hpvgznbllh94">
        <p className="label text-olive" data-id="element-208" data-mp="3dpv2k2oi1622">Step four · The events calendar</p>
        <h2 id="events-h" className="mt-6 max-w-3xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[52px]" data-id="element-209" data-mp="38p7bxi46mr8d">
          No, you can’t import a spreadsheet into Squarespace
        </h2>

        <ul className="mt-12 max-w-3xl border-t border-line" data-id="element-210" data-mp="1xbczrc8hk3xx">
          {eventTruths.map(truth => <li key={truth.slice(0, 24)} className="flex gap-5 border-b border-line py-5 text-[15.5px] leading-[1.8] text-ink/80" data-id="element-211" data-mp="1sap60isvh900">
              <span className="mt-3 h-1.5 w-1.5 shrink-0 bg-peach" aria-hidden="true" data-id="element-212" data-mp="311pohrgjb49n" />
              {truth}
            </li>)}
        </ul>

        <div className="mt-20 grid gap-x-16 gap-y-14 sm:grid-cols-2" data-id="element-213" data-mp="2n3rawoa1fbv7">
          {eventOptions.map(option => <article key={option.name} className="border-t border-line pt-8" data-id="element-214" data-mp="2dbvdlffrzps1">
              <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-215" data-mp="2d9qzk4o5xae1">
                <h3 className="font-display text-[28px] font-300 leading-tight text-ink" data-id="element-216" data-mp="2i44wwcmdxrlc">
                  {option.name}
                </h3>
                <span className={`label px-3 py-1.5 ${verdictStyles[option.verdict]}`} data-id="element-217" data-mp="29a9v9ekh2jag">
                  {option.verdict}
                </span>
              </div>
              <p className="label mt-4 text-muted/80" data-id="element-218" data-mp="1udreldtlr73y">{option.cost}</p>

              <ul className="mt-7 space-y-2.5" data-id="element-219" data-mp="1zb156wsq9otd">
                {option.pros.map(pro => <li key={pro} className="flex gap-3.5 text-[14.5px] leading-relaxed text-ink/80" data-id="element-220" data-mp="1g8iq9tf2rp4x">
                    <span className="mt-2.5 h-1 w-1 shrink-0 bg-olive" aria-hidden="true" data-id="element-221" data-mp="1bfpkr3bs8crs" />
                    {pro}
                  </li>)}
              </ul>
              <ul className="mt-5 space-y-2.5" data-id="element-222" data-mp="11j330ner61tz">
                {option.cons.map(con => <li key={con} className="flex gap-3.5 text-[14.5px] leading-relaxed text-muted" data-id="element-223" data-mp="1z61v0kui2llj">
                    <span className="mt-2.5 h-px w-3 shrink-0 bg-muted/60" aria-hidden="true" data-id="element-224" data-mp="1u6p5ttg5p2fs" />
                    {con}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-20 max-w-3xl bg-foam/45 px-9 py-10" data-id="element-225" data-mp="dsqnaqd9n0su">
          <p className="label text-ink/60" data-id="element-226" data-mp="dua0g83mkvqe">The recommendation</p>
          <h3 className="mt-5 font-display text-[32px] font-300 leading-tight text-ink" data-id="element-227" data-mp="8sug6i99ut92">
            {eventRecommendation.headline}
          </h3>
          <p className="mt-5 text-[16px] leading-[1.9] text-ink/80" data-id="element-228" data-mp="2kfegic868xmb">
            {eventRecommendation.body}
          </p>
        </div>
      </div>
    </section>;
}